import {useCallback, useState} from "react";

/** Use Toggle hook */
export const useToggle = (initialState = false): [boolean, any] => {
    // Initialize the state
    const [state, setState] = useState<boolean>(initialState);
    // Define and memorize toggler function in case we pass down the comopnent,
    // This function change the boolean value to it's opposite value
    const toggle = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (v: any): void =>
            setState((existing) => {
                if (typeof v === "boolean") return v;
                return !existing;
            }),
        []
    );
    return [state, toggle];
};
